import { render, staticRenderFns } from "./PopupValve.vue?vue&type=template&id=07da873a&scoped=true"
import script from "./PopupValve.vue?vue&type=script&lang=js"
export * from "./PopupValve.vue?vue&type=script&lang=js"
import style0 from "./PopupValve.vue?vue&type=style&index=0&id=07da873a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da873a",
  null
  
)

export default component.exports